import { render, staticRenderFns } from "./spt_form.vue?vue&type=template&id=0e8377a6"
import script from "./spt_form.vue?vue&type=script&lang=js"
export * from "./spt_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports